import type { DriverFaceCluster, PageableContent, PageableContentAPI, UpdateDriverFaceClusterRequest } from '@cobliteam/common-types';
import { driverAPIToDriver } from '../driver/APITransformer';
import type { DriverFaceClusterAPI, DriverFaceClusterUpdateRequestAPI } from './definitions/APITypes';

export const toDriverFaceClusterUpdateRequestAPI = (request: UpdateDriverFaceClusterRequest[]): DriverFaceClusterUpdateRequestAPI[] =>
  request.map((req) => ({
    driver_face_cluster_id: req.driverFaceClusterId,
    driver_id: req.driverId,
  }));

export const toDriverFaceCluster = (driverFaceCluster: DriverFaceClusterAPI): DriverFaceCluster => ({
  id: driverFaceCluster.id,
  driver: driverFaceCluster.driver && driverAPIToDriver(driverFaceCluster.driver),
  profileImageUrl: {
    imageUrl: driverFaceCluster.profile_image_url.image_url,
  },
  sampleImageUrls: driverFaceCluster.sample_image_urls.map((cluster) => ({
    imageUrl: cluster.image_url,
  })),
  sampleImageUrlCount: driverFaceCluster.sample_image_url_count,
  createdAt: driverFaceCluster.created_at,
  updatedAt: driverFaceCluster.updated_at,
});

export const toDriverFaceClusterPage = (page: PageableContentAPI<DriverFaceClusterAPI>): PageableContent<DriverFaceCluster> => ({
  content: page.content.map(toDriverFaceCluster),
  last: page.last,
  totalPages: page.total_pages,
  totalElements: page.total_elements,
  numberOfElements: page.number_of_elements,
  number: page.number,
  size: page.size,
  first: page.first,
  empty: page.empty,
});
